import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Toast } from 'primeng/toast';
import { ToastComponent } from './toast.component';

@Component({
  selector: 'app-snackbar',
  imports: [CommonModule, ToastComponent, Toast],
  template: `
    <p-toast
      position="bottom-center"
      [key]="key"
      [baseZIndex]="5000"
      [preventOpenDuplicates]="true"
    >
      <ng-template #message let-message>
        <app-toast [icon]="message.data.icon" [type]="message.data.type">
          <ng-content>{{ message.data.label }}</ng-content>
        </app-toast>
      </ng-template>
    </p-toast>
  `,
  styles: [``],
})
export class SnackbarComponent {
  key = 'snackbar';
}
